import IProductConfigurationItem from 'interfaces/products/IProductConfigurationItem';
import IProductConfigurationAttribute from 'interfaces/products/IProductConfigurationAttribute';

import { INSTALLATION } from 'services/products/productConfigurationItemTypes';
import { INSTALLATION_ID } from 'services/products/productConfigurationAttributeTypes';

const nonNumericFilter = (value: number) => !Number.isNaN(value);

const flattenItems = (
  items: IProductConfigurationItem[]
): IProductConfigurationItem[] =>
  items.reduce(
    (
      flattenedItems: IProductConfigurationItem[],
      item: IProductConfigurationItem
    ) => [...flattenedItems, item, ...flattenItems(item.children)],
    []
  );

const nullStringsFilter = (value: string | null): value is Required<string> =>
  value !== null;

const installationItemsFilter = (item: IProductConfigurationItem) =>
  item.type === INSTALLATION;

const removeDuplicateIdsReducer = (uniqueIds: number[], id: number): number[] =>
  uniqueIds.includes(id) ? uniqueIds : [...uniqueIds, id];

const undefinedAttributesFilter = (
  attribute: IProductConfigurationAttribute | undefined
): attribute is Required<IProductConfigurationAttribute> =>
  attribute !== undefined;

const getInstallationIdsFromProductConfigurationItems = (
  items: IProductConfigurationItem[]
): number[] =>
  flattenItems(items)
    .filter(installationItemsFilter)
    .map((item: IProductConfigurationItem) =>
      item.attributes.find(
        (attribute: IProductConfigurationAttribute) =>
          attribute.type === INSTALLATION_ID
      )
    )
    .filter(undefinedAttributesFilter)
    .map(
      (attribute: IProductConfigurationAttribute): string | null =>
        attribute.value
    )
    .filter(nullStringsFilter)
    .map((value: string): number => parseInt(value, 10))
    .filter(nonNumericFilter)
    .reduce(removeDuplicateIdsReducer, []);

export default getInstallationIdsFromProductConfigurationItems;
